import { makeStyles } from '@material-ui/core/styles';
import zIndex from '@material-ui/core/styles/zIndex';

const useStyles = makeStyles(theme =>({
  wrapper: {
    height: '100%',
    width: '100%',
    [theme.breakpoints.down('sm')]:{

    }
  },
  calendarWrapper: {
    height: 'calc(100% - 153px)',
    [theme.breakpoints.down('sm')]:{
      height: '100%',
      width: '100%',
      overflowX: 'scroll '
    }
   
  },
  columnWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    width: ' 100%'
  },
  column: {
    width: '100%',
    textAlign: 'center',
    
  },
  bookingRow: {
    display: 'flex'
  },
  bookingTitleWrapper: {
    display: 'flex',
    padding: '6px 0',
    backgroundColor: '#E2EBF6',
    [theme.breakpoints.down('sm')]:{
      width: '1000px !important'
     }
    
  },
  bookingTitleBlock: {
    width: '300px',
    minWidth: '300px',
    display: 'flex',
  cursor: 'pointer',
    [theme.breakpoints.down('sm')]:{
     minWidth: '160px'
    }
  },
  bookingAccommodationTitleBgWrapper: {
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
    cursor: 'pointer',
    color: '#FFFFF',
    borderBottom: '1px solid #dbbfe4',
    '&:last-child': {
      borderBottom: '0'
    },
    '&::before': {
      width: '300px',
      content: '""',
      display: 'block',
      position: 'absolute',
      bottom: '-1px',
      height: '1px',
      background: '#dbbfe4',
      [theme.breakpoints.down('sm')]:{
        width: '1000px !important'
       },
    },
    '&:last-child::before': {
      content: '""',
      display: 'none'
    }
  },
  bookingTitle: {
    maxWidth: '240px',
    padding: '0 30px',
    overflow: 'hidden',
    display: 'inline-block',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
   
    flex: '1 0 0px',
    display: 'flex',
    [theme.breakpoints.down('sm')]:{
      width: '150px',
      textOverflow: 'clip',
    }
  },
  bookingTime: {
    minWidth: '250px',
    padding: '6px 0 6px 50px',
    [theme.breakpoints.down('sm')]:{
      minWidth: '150px'
    }
  },
  bookingParticipantsRow: {
    borderBottom: '1px dashed #E2EBF6',
    position: 'relative',
    '&:last-child': {
      borderBottom: '0'
    },
    '&::before': {
      width: '300px',
      content: '""',
      display: 'block',
      position: 'absolute',
      bottom: '-1px',
      height: '1px',
      background: 'white'
    },
    '&:last-child::before': {
      content: '""',
      display: 'none'
    }
  },
  participantsColumn: {
    borderLeft: '1px solid #E2EBF6'
  },
  participants: {
    display: 'flex',
    justifyContent: 'space-between',
    height: '19px',
    color: '#FFF',
    backgroundColor: '#0E8BB4',
    margin: '6px 10px',
    padding: '0 10px',
    borderRadius: '3px',
    overflow: 'hidden',
    textAlign: 'left',
    display: 'flex',
    WebkitBoxAlign: 'center',
    alignItems: 'center',
    padding: '0.813rem 0 0.813rem 1rem',
    minHeight: '56px',
    height: 'calc(56px)',
    borderTop: '1px solid rgb(210, 210, 210)',
    transition: '0.5s',
    [theme.breakpoints.down('sm')]:{
      width: '120px',
      textAlign: 'center',
      // padding: '0.813rem 0',
    }
  },
  participantsHover: {
    cursor: 'pointer'
  },
  noParticipants: {
    height: '17px',
    background:
      'repeating-linear-gradient(-59.5deg, #fff, #fff 5px, #E2EBF6 5px, #E2EBF6 10px)',
    margin: '6px 10px',
    border: '1px solid #E2EBF6',
    borderRadius: '3px',
    overflow: 'hidden',
    position: 'relative',
    borderBottomRightRadius: 0,
    display: 'flex',
    WebkitBoxAlign: 'center',
    alignItems: 'center',
    padding: '0.813rem 0 0.813rem 1rem',
    minHeight: '56px',
    height: 'calc(56px)',
    border: '1px solid rgb(210, 210, 210)',
    transition: '0.5s',
    [theme.breakpoints.down('sm')]:{
      width: '120px',
      textAlign: 'center',
      margin: '6px auto',
      
    }
  },
  participantsStart: {
    borderRight: 'none',
    margin: '6px -1px 6px 10px',
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    display: 'flex',
    WebkitBoxAlign: 'center',
    alignItems: 'center',
    padding: '0.813rem 0 0.813rem 1rem',
    width: '100%',
    minHeight: '56px',
    height: 'calc(56px)',
    border: '1px solid rgb(210, 210, 210)',
    transition: '0.5s',
    [theme.breakpoints.down('sm')]:{
      width: '120px',
      textAlign: 'center',
      margin: '6px auto',
      // padding: '0.813rem 0',
    }
  },
  participantsHalfStart: {
    overflow: 'visible',
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    margin: '6px -50px 6px 50%',
    position: 'relative',
    display: 'flex',
    WebkitBoxAlign: 'center',
    alignItems: 'center',
    padding: '0.813rem 0 0.813rem 1rem',
    minHeight: '56px',
    height: 'calc(56px)',
    borderTop: '1px solid rgb(210, 210, 210)',
    transition: '0.5s',
    [theme.breakpoints.down('sm')]:{
      width: '120px',
      textAlign: 'center',
      margin: '6px auto',
      // padding: '0.813rem 0',
    }
  },
  participantsHalfDate: {
    overflow: 'visible',
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    margin: '6px -50px 6px 50%',
    position: 'relative',
    [theme.breakpoints.down('sm')]:{
      width: '120px',
      textAlign: 'center',
      margin: '6px auto',
      // padding: '0.813rem 0',
    }
  },
  participantsMid: {
    display: 'flex',
    WebkitBoxAlign: 'center',
    alignItems: 'center',
    padding: '0.813rem 0 0.813rem 1rem',
    width: '101%',
    minHeight: '56px',
    height: 'calc(56px)',
    transition: '0.5s',
    cursor: 'pointer',
    overflow: 'visible',
    borderRight: 'none',
    borderLeft: 'none',
    margin: '6px 0 6px 0',
    borderRadius: 0,
    position: 'relative',
    
    [theme.breakpoints.down('sm')]:{
      width: '120px',
      textAlign: 'center',
      // margin: '6px auto',
    }
  },
  participantsEnd: {
    borderLeft: 'none',
    margin: '6px 10px 6px -1px',
    borderRadius: '3px',
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
    display: 'flex',
    WebkitBoxAlign: 'center',
    alignItems: 'center',
    padding: '0.813rem 0 0.813rem 1rem',
    width: '100%',
    minHeight: '56px',
    height: 'calc(56px)',
    border: '1px solid rgb(210, 210, 210)',
    transition: '0.5s',
    [theme.breakpoints.down('sm')]:{
      width: '120px',
      textAlign: 'center',
      margin: '6px auto',
      padding: '0.813rem 0',
      borderRadius: '3px',
    }
  },
  participantsHalfEnd: {
    maxWidth:'150px',
    overflow: 'visible',
    borderRadius: 0,
    borderTopRightRadius: '3px',
    borderBottomRightRadius: '3px',
    border:'3px',
    margin: '6px 50% 6px -1px',
    position: 'relative',
    display: 'flex',
    WebkitBoxAlign: 'center',
    alignItems: 'center',
    padding: '0.813rem 0 0.813rem 1rem',
    minHeight: '56px',
    height: 'calc(56px)',
    borderTop: '1px solid rgb(210, 210, 210)',
    transition: '0.5s',
    [theme.breakpoints.down('sm')]:{
      width: '120px',
      textAlign: 'center',
      margin: '6px auto',
      // padding: '0.813rem 0',
      borderRadius: '3px',
      
    }
  },
  activeProduct: {
    height: '30px',
    border: 1,
    background: 'white', 
    margin: '6px 0px 6px 0',
    [theme.breakpoints.down('sm')]: {
      // width: '100%',
      margin: '6px auto',
    },
  },
  bookingsList: {
    height: '100%',
    overflow: 'auto',
    [theme.breakpoints.down('sm')]:{
      width: '100%',
      overflow: 'visible',   
    }
    
  },
  header: {
    display: 'flex',
    boxShadow: '0px 1px 0px #E2EBF6',
    padding: '0 25px'
  },
  backAction: {
    display: 'flex',
    alignItems: 'center',
    padding: '9px 25px 9px 0',
    boxShadow: '1px 0px 0px #E2EBF6'
  },
  backButtonTitle: {
    color: '#59758B'
  },
  backIcon: {
    fontSize: '18px',
    color: '#59758B'
  },
  headerTitle: {
    borderLeft: '1px solid #E2EBF6',
    borderRadius: 1,
    color: '#071B27',
    marginLeft: '5px',
    paddingLeft: '15px'
  },
  rangeWrapper: {
    display: 'flex',
    alignItems: 'center',
    paddingLeft: '30px'
  },
  button: {
    border: '1px solid #0E8BB4',
    borderRadius: '3px',
    padding: '5px 29px'
  },
  todayTitle: {
    color: '#0E8BB4',
    fontWeight: 'bold'
  },
  range: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: '30px'
  },
  rangeIcon: {
    fontSize: '10px',
    border: '1px solid #000',
    borderRadius: '100%',
    padding: '1px',
    cursor: 'pointer'
  },
  rangeDates: {
    margin: '0 15px'
  },
  loaderClassName: {
    width: '80px !important',
    height: '80px !important'
  },
  loaderWrapper: {
    position: 'fixed'
  },

  bookingImage: {
    marginRight: '0.5rem',
    width: '2.5rem',
    height: '2.5rem',
    borderRadius: '50%',
    overflow: 'hidden',
    flexShrink: 0,
  },

  bookingTitleText:{
    margin: 0,
    padding: 0,
    fontSize: '0.80rem',
    lineHeight: '1.125rem',
    color: 'rgb(28, 34, 47)',
    textOverflow: 'ellipsis',
    display: 'inline-block',
    maxWidth: '144px',
    width: '100%',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textAlign: 'left',
    fontWeight: '600'
    
  },
  bookingProductCode:{
  margin: 0,
  padding: 0,
  fontSize: '0.625rem',
  letterSpacing: '0.5px',
  lineHeight: '0.75rem',
  color: 'rgb(119, 119, 119)',
  textOverflow: 'ellipsis',
  display: 'inline-block',
  maxWidth: '144px',
  width: '100%',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textAlign: 'left',
  },
  wrapperTitle:{
    display: 'flex',
    flexDirection:'column',
    textAlign: 'center',
    justifyContent: 'center'
  },

  activityparticipants:{
    display: 'flex',
    justifyContent: 'space-between',
    height: '19px',
    color: '#FFF',
    backgroundColor: '#335267',
    margin: '6px 10px',
    padding: '0 10px',
    borderRadius: '3px',
    overflow: 'hidden',
    textAlign: 'left',
    display: 'flex',
    WebkitBoxAlign: 'center',
    alignItems: 'center',
    padding: '0.813rem 0 0.813rem 1rem',
    minHeight: '56px',
    height: 'calc(56px)',
    borderTop: '1px solid rgb(210, 210, 210)',
    transition: '0.5s',
    [theme.breakpoints.down('sm')]:{
      width: '100px',
      textAlign: 'center',
    }
  },
  activitynoParticipants:{
    height: '17px',
    background:
      'repeating-linear-gradient(-59.5deg, #fff, #fff 5px, #E2EBF6 5px, #E2EBF6 10px)',
    margin: '6px 10px',
    border: '1px solid #E2EBF6',
    borderRadius: '3px',
    overflow: 'hidden',
    position: 'relative',
    borderBottomRightRadius: 0,
    display: 'flex',
    WebkitBoxAlign: 'center',
    alignItems: 'center',
    padding: '0.813rem 0 0.813rem 1rem',
    minHeight: '56px',
    height: 'calc(56px)',
    border: '1px solid rgb(210, 210, 210)',
    transition: '0.5s',
    [theme.breakpoints.down('sm')]:{
      width: '100px',
      textAlign: 'center',
    }
  },
  guestName: {
    fontSize: '14px',
    color: 'white',
    fontWeight: '600',
    zIndex: '1',
    textOverflow: 'ellipsis',        
    overflow: 'hidden',   
    display: '-webkit-box',           
    '-webkit-line-clamp': '2',        
    '-webkit-box-orient': 'vertical'  
  },
}));

export default useStyles;


